import axios from "axios";

const api = axios.create();

const MAX_POST_SIZE_BYTES = 8 * 1024 * 1024; // 8 MB

if (config.public_url.search('http') > -1) {
	api.defaults.baseURL = config.public_url.substr(-1) === "/" ? config.public_url : config.public_url.slice(0, -1);
}
api.defaults.withCredentials = true;
api.defaults.headers.common["Ajax"] = true;
api.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
api.defaults.headers.put["Content-Type"] = "application/x-www-form-urlencoded";

api.interceptors.request.use(
	function (config) {
		let token = window.authService ? window.authService.retrieveToken() : false;

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		// Only check for POST requests with data
		if (config.method === 'post' && config.data) {
			let requestBodySize = 0;

			// Determine the size based on the data type
			if (typeof config.data === 'string') {
				requestBodySize = new TextEncoder().encode(config.data).length;
			} else if (config.data instanceof FormData) {
				// For FormData, you might need to iterate through entries to estimate size
				// or rely on a more robust size calculation if exactness is critical.
				// This is a simplified estimation.
				for (const pair of config.data.entries()) {
					if (typeof pair[1] === 'string') {
						requestBodySize += new TextEncoder().encode(pair[1]).length;
					} else if (pair[1] instanceof Blob) {
						requestBodySize += pair[1].size;
					}
				}
			} else if (typeof config.data === 'object') {
				requestBodySize = new TextEncoder().encode(JSON.stringify(config.data)).length;
			}

			if (requestBodySize > MAX_POST_SIZE_BYTES) {
				return Promise.reject(new Error('Request body exceeds the maximum allowed size.'));
			}
		}

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	function (response) {
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		return response;
	},
	function (error) {
		if (error.status === 406 && error.response.data.doCheckbox) {
			console.log("recaptcha challenge", error);
			window.reCaptchaService.doCheckbox();
		} else if (error.status === 401) {
			window.authService.showDialog();
		}
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		return Promise.reject(error);
	}
);

window.axios = api;